module.exports = __webpack_public_path__ + "static/font-ddffc363118a6ecc25036c7c0adadef7.woff2";